import { render, staticRenderFns } from "./ExpiredBadgePopover.vue?vue&type=template&id=baa87da8&scoped=true"
import script from "./ExpiredBadgePopover.vue?vue&type=script&lang=js"
export * from "./ExpiredBadgePopover.vue?vue&type=script&lang=js"
import style0 from "./ExpiredBadgePopover.vue?vue&type=style&index=0&id=baa87da8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa87da8",
  null
  
)

export default component.exports